import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Logo from "../sharable/Logo";
import {
  ErrosWrapper,
  InputWrapper,
  Modal,
  ModalHeader,
  TextLink,
} from "../../SharableStyles/FormStyle";
import { IonIcon } from "@ionic/react";
import {
  mailOpen,
  mailOpenOutline,
  mailOpenSharp,
  navigate,
} from "ionicons/icons";
import { Input } from "../sharable/InputStyle";
import Button from "../sharable/ActionButton";
import { emailRegex, passwordRegex, validateField } from "../../services/Utils";
import FormMessage from "../sharable/FormMessage";
import { AppearAnimation } from "../sharable/ModalPopup";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import useFormValidation from "../sharable/hooks/useFormValidation";
import Help from "../sharable/Help";
import { devices } from "../../Devices";
import PasswordToggle from "../sharable/hooks/PasswordToggle";
const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  background-image: url("images/cta-bg.png");
  background-size: cover;
  flex-direction: column;
  header {
    padding: 2rem 4.2rem;
    display: flex;
    justify-content: start;
    align-self: start;
    width: 100%;
    margin-bottom: 9.2rem;
  }

  ${ModalHeader} {
    padding: 2rem 3.6rem;
  }
`;

const Main = styled.main`
  align-items: center;
  justify-content: space-around;
  .mail-icon {
    font-size: 12rem;
  }
  p {
    font-size: 1.2rem;
  }
  gap: 2.4rem;
  padding: 0 3.6rem 3.6rem 3.6rem;

  .wrapper {
    margin-top: 2rem;
    gap: 1rem;
  }

  .email-input {
    min-width: 30rem;
  }

  @media ${devices.mobileL} {
    .mail-icon {
      display: none;
    }
    .email-input {
      min-width: 15rem;
    }
  }
`;

const RecoveryModal = styled(Modal)`
  animation: ${AppearAnimation} 500ms linear;
`;

const RECOVERY_MODAL = "request_code";
const VALIDATION_MODAL = "code_validation";
const PASSWORD_UPDATE_MODAL = "password_update";
export default function AccountRecovery() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  console.log(searchParams.get("step"));
  return (
    <Container>
      <Help color="white" />
      <header>
        <Logo
          showGoBackButton={true}
          path={"/entrar"}
          color={"white"}
          size={12}
        />
      </header>

      {searchParams.get("step") === VALIDATION_MODAL ? (
        <CodeValidationModal />
      ) : searchParams.get("step") === PASSWORD_UPDATE_MODAL ? (
        <PasswordUpdateModal />
      ) : searchParams.get("step") === RECOVERY_MODAL ? (
        <RecoveryEmailModal />
      ) : (
        <p>
          Não foi possível carregar essa página.{" "}
          <TextLink
            onClick={() => {
              navigate("/entrar");
            }}
          >
            Voltar para tela de login
          </TextLink>
        </p>
      )}
    </Container>
  );
}

const CodeValidationModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [validationError, setValidationError] = useState();
  const { values, errors, handleChange, validate } = useFormValidation({
    code: {
      label: "code",
      required: true,
      minLength: 10,
      maxLength: 10,
      customMessages: {
        minLength: "Código deve ter 10 dígitos",
        maxLength: "Código deve ter apenas 10 dígitos",
      },
    },
  });

  /* UPDATE RECOVERY CODE VALUE WITH SEARCH PARAMS IN CASE USER RELOADS URL */
  useEffect(() => {
    if (searchParams.get("code"))
      handleChange("code", searchParams.get("code") || "");
  }, [searchParams]);

  const validateRecoveryCode = async () => {
    if (!validate()) {
      return;
    }
    const res = await fetch(
      `${BASE_URL}account-recovery?email=${searchParams.get("email")}&code=${
        values.code
      }`,
      { method: "POST" }
    );
    if (res.ok) {
      const recoveryToken = await res.text();
      setSearchParams(
        (prev) => {
          const newSearchParams = new URLSearchParams(prev);
          newSearchParams.set("step", PASSWORD_UPDATE_MODAL);
          newSearchParams.set("recoveryToken", recoveryToken);
          return newSearchParams;
        },
        { replace: true }
      );
    } else if (res.status === 401) setValidationError(401);
    else if (res.status === 404) setValidationError(404);
  };
  return (
    <Modal>
      <ModalHeader>
        <h1>código de recuperação</h1>
        <p>
          Digite o código que você recebeu no email para atualizar sua senha
        </p>
      </ModalHeader>
      <Main className="flex">
        <div>
          <div className="wrapper flex min-gap direction-column">
            {validationError == 404 && (
              <FormMessage
                message={`Usuário ${searchParams.get("email")} não encontrado.`}
                textLink={"Voltar para tela de login"}
                linkTo={"/entrar"}
              />
            )}
            {validationError == 401 && (
              <FormMessage
                message={"Código incorreto ou possivelmente expirado."}
                textLink={"Voltar para tela de login"}
                linkTo={"/entrar"}
              />
            )}
            <Input
              placeholder="Cole o código aqui"
              onInput={(e) => {
                console.log(e.target.value);
                handleChange("code", e.target.value);
              }}
              defaultValue={values.code}
            />
            <ErrosWrapper>
              {errors.code &&
                errors?.code.map((error) => (
                  <FormMessage
                    message={error}
                    backgroundColor={"transparent"}
                    align={"left"}
                  />
                ))}
            </ErrosWrapper>

            <Button
              $fullWidth
              text={"verificar"}
              action={validateRecoveryCode}
            />
          </div>
        </div>{" "}
        <IonIcon icon={mailOpenOutline} className="mail-icon" />
      </Main>
    </Modal>
  );
};

const PasswordUpdateModal = () => {
  const [errorMessage, setErrorMessage] = useState();
  const [searchParams] = useSearchParams();
  const [successMessage, setSuccessMessage] = useState();
  const [passwordUpdateError, setPasswordUpdateError] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const { values, errors, handleChange, validate } = useFormValidation({
    password: {
      label: "Nova senha",
      required: true,
      minLength: 10,
      maxLength: 20,
      customMessages: {
        minLength: "Senha muito curta: Mínimo  10 caracteres",
        maxLength: "Senha muito grande: Máximo 20 caracteres",
      },
    },
    passwordConfirmation: {
      label: "Repetir nova senha",
      required: true,
      minLength: 10,
      maxLength: 20,
      customMessages: {
        minLength: "Senha muito curta: Mínimo  10 caracteres",
        maxLength: "Senha muito grande: Máximo 20 caracteres",
      },
    },
  });
  const navigate = useNavigate();
  const updatePassword = async () => {
    if (!validate() || values.password != values.passwordConfirmation) return;
    const recoveryToken = searchParams.get("recoveryToken");
    const email = searchParams.get("email");
    const body = {
      email: email,
      password: values.password,
    };

    const res = await fetch(`${BASE_URL}auth/basic/password-update`, {
      method: "PUT",
      headers: {
        Authorization: recoveryToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (res.ok) {
      setSuccessMessage(
        "Sua senha foi alterada com sucesso, você será redirecionado para a tela de login ;)"
      );
      setTimeout(() => {
        navigate("/entrar");
      }, 5000);
    } else if (res.status === 404) setPasswordUpdateError(404);
    else if (res.status === 403) setPasswordUpdateError(403);
  };
  return (
    <Modal>
      <ModalHeader>
        <h1>alterar senha</h1>
        <p>
          Anote sua senha em algum local seguro para caso você esqueça novamente
          ;).
        </p>
      </ModalHeader>
      <Main>
        {successMessage && (
          <FormMessage message={successMessage} type="success" />
        )}

        <InputWrapper className="flex direction-column min-gap">
          {passwordUpdateError == 404 && (
            <FormMessage
              message={`Usuário ${searchParams.get("email")} não encontrado.`}
              textLink={"Voltar para tela de login"}
              linkTo={"/entrar"}
            />
          )}
          {passwordUpdateError == 403 && (
            <FormMessage
              message={"Token inválido para alteração de senha."}
              textLink={"Voltar para tela de login"}
              linkTo={"/entrar"}
            />
          )}
          {values.password &&
            values.passwordConfirmation &&
            values.password !== values.passwordConfirmation && (
              <FormMessage message={"As senhas devem ser iguais."} />
            )}
          <Input
            placeholder="Nova Senha"
            onInput={(e) => handleChange("password", e.target.value)}
            type={`${showPassword ? "text" : "password"}`}
          />
          <ErrosWrapper>
            {errors.password &&
              errors?.password.map((error) => (
                <FormMessage
                  message={error}
                  backgroundColor={"transparent"}
                  align={"left"}
                />
              ))}
          </ErrosWrapper>
          <Input
            placeholder="Repetir nova senha"
            onInput={(e) =>
              handleChange("passwordConfirmation", e.target.value)
            }
            type={`${showPassword ? "text" : "password"}`}
          />

          <PasswordToggle
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            password={values.password}
          />

          <ErrosWrapper>
            {errors.passwordConfirmation &&
              errors?.passwordConfirmation.map((error) => (
                <FormMessage
                  message={error}
                  backgroundColor={"transparent"}
                  align={"left"}
                />
              ))}
          </ErrosWrapper>
          <Button text={"Atualizar senha"} $fullWidth action={updatePassword} />
        </InputWrapper>
      </Main>
    </Modal>
  );
};

const RecoveryEmailModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { values, errors, handleChange, validate } = useFormValidation({
    email: {
      label: "email",
      required: true,
      regex: emailRegex,
      customMessages: {
        regex: "Esse email é inválido.",
      },
    },
  });

  useEffect(() => {
    handleChange("email", searchParams.get("email"));
  }, []);

  const [recoveryError, setRecoveryError] = useState();
  const requestRecoveryCodeNotification = async () => {
    setRecoveryError(undefined);
    if (!validate()) {
      return;
    }

    const res = await fetch(
      `${BASE_URL}account-recovery?email=${values.email}`
    );
    const statusMessage = await res.text();

    if (res.ok) {
      setSearchParams(
        (prev) => {
          const newSearchParams = new URLSearchParams(prev);
          newSearchParams.set("step", VALIDATION_MODAL); // Set your static value here

          return newSearchParams;
        },
        { replace: true }
      );
    } else {
      setRecoveryError(statusMessage);
      console.log(statusMessage);
    }
  };
  return (
    <Modal>
      <ModalHeader>
        <h1>Recuperar conta</h1>
        <p>Altere a senha da sua conta</p>
      </ModalHeader>
      <Main className="flex">
        <div>
          <div className="flex min-gap direction-column">
            <h2>
              Clique em "Enviar código" para receber o código em seu email
            </h2>
            <div className="wrapper flex min-gap direction-column">
              {recoveryError === "This user does not exists." && (
                <FormMessage
                  message={"Não existe nenhuma conta vinculada a esse email."}
                />
              )}
              {recoveryError ===
                "You cannot change your password. Different authentication method." && (
                <FormMessage
                  message={
                    "Não é possível alterar a senha pois sua conta está vinculada a sua conta Google"
                  }
                  textLink={"Entre com sua conta google"}
                  linkTo={"/entrar"}
                />
              )}

              {recoveryError === "Validation required." && (
                <FormMessage
                  message={
                    "Não foi possível continuar com essa ação. Enviamos um email para que valide sua conta."
                  }
                />
              )}
              {recoveryError ===
                "Please wait before requesting another code." && (
                <FormMessage
                  message={
                    "Por favor, espere antes de solicitar um novo código."
                  }
                />
              )}
              <Input
                className="email-input"
                placeholder="Email"
                onInput={(e) => handleChange("email", e.target.value)}
                defaultValue={values.email}
              />
              <ErrosWrapper>
                {errors.email &&
                  errors?.email.map((error) => (
                    <FormMessage
                      message={error}
                      backgroundColor={"transparent"}
                      align={"left"}
                    />
                  ))}
              </ErrosWrapper>

              {!recoveryError && (
                <Button
                  text={"Enviar código"}
                  action={requestRecoveryCodeNotification}
                  $fullWidth
                />
              )}
            </div>
          </div>
        </div>
        <IonIcon icon={mailOpenOutline} className="mail-icon" />
      </Main>
    </Modal>
  );
};
